import React from "react";
import { Card, CardContent, Button } from "@mui/material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { useNavigate } from "react-router-dom";

// ------- MASTER LOTTERY DATA (20 cards) -------
const AllLotteries = Array.from({ length: 20 }).map((_, i) => ({
  id: i + 1,
  title:
    i < 5
      ? "Monthly Lotteries"
      : i < 10
      ? "Weekly Lotteries"
      : i < 15
      ? "Daily Lotteries"
      : "Yearly Lotteries",

  prize: `${10 + i * 2} Lakhs`,
  ticketName: `Super Ticket ${i + 1}`,
  date: `12.${10 + (i % 20)}.2025`,
  time: "6:30 PM",
  ticketPrice: 20 + i * 5,

  prizeText: "linear-gradient(to right, #f43f5e, #f59e0b, #3b82f6)",
  buttonBg: "#f43f5e",
  cardBg: "#fff",
}));

// ------- CARD COMPONENT -------
const LotteryCard = ({ data }) => {
      const navigate = useNavigate();

  return (
    <Card
      className="lottery-card"
      style={{
        background: data.cardBg,
        borderRadius: 20,
        overflow: "hidden",
        marginBottom: 25,
      }}
    >
      <CardContent>
        <div className="prize-section">
          <h6 style={{ color: "#f31212ff" }}>Win First Prize</h6>

          <div className="prize-amount">
            <CurrencyRupeeIcon style={{ color: "#181717ff", fontSize: 36 }} />
            <h2
              className="prize-text"
              style={{
                background: data.prizeText,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: 32,
                fontWeight: "bold",
                marginLeft: 8,
              }}
            >
              {data.prize}
            </h2>
          </div>
        </div>

        <div className="ticket-info" style={{ marginBottom: 15 }}>
          <p style={{ fontWeight: 600 }}>{data.ticketName}</p>
          <div
            className="info-details"
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 14,
            }}
          >
            <p>Date: {data.date}</p>
            <p>Time: {data.time}</p>
          </div>
        </div>

        <div className="ticket-price" style={{ textAlign: "center", marginBottom: 15 }}>
          <h4>Ticket Price: ₹{data.ticketPrice}</h4>
        </div>

        <Button
          fullWidth
          style={{
            backgroundColor: data.buttonBg,
            color: "#fff",
            fontWeight: "bold",
            padding: "10px",
            borderRadius: 50,
            boxShadow: "0 6px 10px rgba(0,0,0,0.3)",
          }}
          onClick={() => navigate("/ticket-select")}
        >
          Buy Now
        </Button>
      </CardContent>
    </Card>
  );
};

// ------- GRID COMPONENT -------
const LotterySection = ({ title, items }) => (
  <div style={{ marginBottom: 50 }}>
    <h2 className="section-title">{title}</h2>

    <div className="lottery-grid">
      {items.map((item) => (
        <div key={item.id} className="lottery-col">
          <LotteryCard data={item} />
        </div>
      ))}
    </div>
  </div>
);

// ------- MAIN COMPONENT -------
const Lotteries = () => {
  return (
    <div style={{ padding: 20 }}>
      {/* MONTHLY */}
      <LotterySection
        title="📅 Monthly Lotteries"
        items={AllLotteries.filter((x) => x.title === "Monthly Lotteries")}
      />

      {/* WEEKLY */}
      <LotterySection
        title="🗓 Weekly Lotteries"
        items={AllLotteries.filter((x) => x.title === "Weekly Lotteries")}
      />

      {/* DAILY */}
      <LotterySection
        title="🔥 Daily Lotteries"
        items={AllLotteries.filter((x) => x.title === "Daily Lotteries")}
      />

      {/* YEARLY */}
      <LotterySection
        title="🎉 Yearly Lotteries"
        items={AllLotteries.filter((x) => x.title === "Yearly Lotteries")}
      />
    </div>
  );
};

export default Lotteries;
